import { render, staticRenderFns } from "./handleLabel.vue?vue&type=template&id=fca5eb32&functional=true"
import script from "./handleLabel.vue?vue&type=script&lang=js"
export * from "./handleLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports